import { useSelector } from "react-redux";
import RecordEditor from "../../../../shared/ui/common/RecordEditor";
import { saveAdvertisementData } from "../../api/advertisment-data";
const fields = [{ name: "advertisementId", label: "شناسه آگهی", numeric: true },
  { name: "fieldId", label: "شناسه فیلد", numeric: true }, { name: "value", label: "مقدار", multiline: true }];
export default function DataEditor({ editing, ...props }) {
  const { token } = useSelector((state) => state.user);
  return <RecordEditor {...props} title={editing ? "ویرایش داده آگهی" : "افزودن داده آگهی"} fields={fields}
    save={(values) => saveAdvertisementData({ id: props.data?.id, ...values }, token, editing)} />;
}
